// Demo-loop helpers — replay HealthSources + Onboarding + Spotlight tour on
// every login for sales/walkthrough accounts. Real metrics, nutrition logs
// and integrations stay intact (handled server-side in /auth/demo-reset).
//
// Pattern: any of these emails triggers the demo loop on login:
//   - demo@wing.app (the seeded primary)
//   - anything @demo.wing.app (shadow accounts for additional walkthroughs)
//
// The login flow does:
//   1. POST /auth/demo-reset → server clears `onboarded` + `dashboard_order`
//   2. Refresh user (so AuthContext sees `onboarded === false`)
//   3. Clear all `wing.spotlight.seen.*` localStorage flags
//   4. Caller navigates to /onboarding/health-sources

import api from "@/api";

const DEMO_PRIMARY = "demo@wing.app";
const DEMO_DOMAIN  = "demo.wing.app";

export function isDemoLoopEmail(email) {
    if (!email) return false;
    const e = String(email).toLowerCase().trim();
    return e === DEMO_PRIMARY || e.endsWith("@" + DEMO_DOMAIN);
}

/** True if the currently authenticated user is in the demo loop. */
export function isDemoLoopUser(user) {
    return isDemoLoopEmail(user?.email);
}

/** Clear every persisted spotlight "seen" flag so tours auto-replay. */
export function clearSpotlightFlags() {
    try {
        Object.keys(localStorage)
            .filter((k) => k.startsWith("wing.spotlight.seen."))
            .forEach((k) => localStorage.removeItem(k));
    } catch { /* private mode / quota — silent */ }
}

/**
 * Run the demo-loop reset and clear local spotlight flags. Returns the
 * refreshed user (with onboarded=false) on success, or null on failure.
 * Caller is responsible for navigation.
 */
export async function runDemoLoopReset() {
    try {
        const { data } = await api.post("/auth/demo-reset");
        clearSpotlightFlags();
        return data;
    } catch {
        // Backend rejects (403) for non-demo accounts; just no-op then.
        return null;
    }
}
